<template>
  <div class="ac-card-content">
    <div class="ac-body-container">
      <img
        src="@shared/assets/img/logo/smart-maintenance-grey.png"
        class="ac-logo"
        alt="Smart Maintenance®"
      >
      <div class="ac-header">
        Promo Wizard
      </div>
      <div class="ac-plan-container">
        <div class="ac-plan-header">
          <img
            src="@shared/assets/img/setting/plan-icon.svg"
            alt="Service Plans"
          >
          Create limited-time offers
        </div>
        <div class="ac-plan-body">
          Engage your customers with special promotions and boost your business
        </div>
      </div>
      <div class="ac-plan-container">
        <div class="ac-plan-header">
          Add Images
        </div>
        <div class="ac-plan-body">
          Upload one image by default, or add a separate preview
          image. Advanced users can opt to display an image
          spanning the full page.
        </div>
      </div>
      <div class="ac-plan-container">
        <div class="ac-plan-header">
          Offer Type and Delivery
        </div>
        <div class="ac-plan-body">
          Choose how long the promotion should run for. You can
          also choose the way your customers should be notified
          about the promotion.
        </div>
      </div>
      <div class="ac-plan-container">
        <div class="ac-plan-header">
          Promotion Info
        </div>
        <div class="ac-plan-body">
          Choose what will happen when a customer interacts
          with your promotion. You can link to a website or
          start a phone call. In ‘More Details,’ list any fine
          print.
        </div>
      </div>
      <div class="ac-plan-container">
        <div class="ac-plan-header">
          <img
            src="@shared/assets/img/setting/eye-icon.svg"
            alt="Archive"
          >
          Archiving a Promo
        </div>
        <div class="ac-plan-body">
          Need to make changes? Archiving will remove the
          promotion as an option for customers.
        </div>
      </div>
      <div class="ac-plan-container">
        <div class="ac-plan-header">
          <img
            src="@shared/assets/img/setting/red-x-circle.svg"
            alt="Comfort Credits"
          >
          Deleting a Plan
        </div>
        <div class="ac-plan-body">
          If you would like to delete a promotion, please
          contact your Partner Success Manager directly or email
          <a href="mailto:partners@smartac.com">
            partners@smartac.com.
          </a>
        </div>
      </div>
      <div class="ac-button-container">
        <button
          type="button"
          class="ac-button"
          @click="close"
        >
          Cancel
        </button>
        <button
          v-if="openBuilder"
          type="button"
          class="ac-button"
          @click="openBuilder"
        >
          Create Promo
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PromoInfo',
  props: {
    close: Function,
    openBuilder: Function,
  },
};
</script>
